module.exports = __webpack_public_path__ + "img/wall1.5865ff43.png";